module.exports = __webpack_public_path__ + "img/map.b6238e65.png";